import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  Badge,
  Typography,
  useTheme,
  useMediaQuery,
  Drawer,
} from "@material-ui/core";


import logo from '../../assets/logo.svg'
import search from '../../assets/search.svg'
import cart from '../../assets/cart.svg'

import useStyles from './styles'
import { Link, useLocation } from 'react-router-dom'
import Utils from "../../lib/Utils";
import NavbarDrawer from "./NavbarDrawer";


const Navbar = ({ totalItems, onSearchOpen }) => {
  const classes = useStyles()
  const location = useLocation();

  const [loggedIn, setLoggedIn] = useState(false);

  useEffect(() => {
    if (Utils.CheckUser()) {
      setLoggedIn(true);
    }
  }, [])

  const openSearch = () => onSearchOpen(true);

  const logout = () => {
    Utils.ClearUser();
    window.location.href = "/"
  }

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <AppBar
        position="fixed"
        className={classes.appBar}
        color="inherit">
        <Toolbar className={`${classes.navbar} ${location.pathname !== '/' ? classes.greyNav : ""}`}>
          <Typography varient="h6" className={classes.title} color="inherit" component={Link} to="/">
            <img src={logo} alt="LOGO GIFTSWAP" height="25px" className={classes.image} />
          </Typography>
          <div className={classes.grow} />
          {isMobile ? (
            <NavbarDrawer onSearchOpen={openSearch} totalItems={totalItems}></NavbarDrawer>
          ) : (
            <div className="col-8 main-menu">
              <ul className="desktop-only">
                <li className={` ${location.pathname === '/' ? "active" : ""}`} ><Link to="/" >Buy gift cards</Link></li>
                <li className={` ${location.pathname === '/products' ? "active" : ""}`} ><Link to="/products" >Catalog</Link></li>
                {/* <li className={` ${location.pathname === '/promos' ? "active" : ""}`}>Promo</li> */}
                {/* <li className={` ${location.pathname === '/deals' ? "active" : ""}`}>Deals</li> */}
                <li className={` ${location.pathname === '/blog' ? "active" : ""}`}><Link to="/blog" >Blog</Link></li>
                
                {!loggedIn ? (
                  <>
                    <li className="underline">
                      <Link to={"/auth"}>Create account</Link>
                    </li>
                    <li>
                      <Link to={'/auth/login'} className="btn btn-black">Login</Link>
                    </li>
                  </>
                ) :
                  <>
                    <li className={` ${location.pathname === '/myorders' ? "active" : ""}`}><Link to="/myorders">My Orders</Link></li>
                    <li className={` ${location.pathname === '/support/mytickets' ? "active" : ""}`}><Link to="/support/mytickets">My Tickets</Link></li>
                    <li onClick={logout} className="btn">Logout</li>
                  </>
                }
                <li onClick={openSearch}><img src={search} className="site-icon search" alt="search" /> </li>
                <li>
                  <Badge badgeContent={totalItems} color="secondary">
                    <Link to="/cart">
                      <img src={cart} className="site-icon search" alt="cart" />
                    </Link>
                  </Badge>
                </li>
              </ul>
            </div>
          )}
        </Toolbar>

      </AppBar>
      <div className="navbar-spacing" />
    </>
  );
};

export default Navbar;
